export default __webpack_public_path__ + "static/media/knife.1121c0a5.png";